import DateRangeFields from 'components/Form/dateRangeFields';
import FilterDrawerShell from 'components/Form/filterDrawerShell';
import FilterSection from 'components/Form/filterSection';
import { countActive, filterValueOf } from 'components/Form/filterValues';

const ISSUED_KEYS = ["issued_date_after", "issued_date_before"];
const RETURNED_KEYS = ["returned_date_after", "returned_date_before"];

const AssetFilterDrawer = ({
    handleFilterDrawer,
    showFilterDrawer,
    filters,
    handleApplyFilter,
    filterLoading,
    handleDateChange,
    handleClearAll,
    isFilterDirty
}) => {
  const valueOf = (key) => filterValueOf(filters, key);
  return (
    <FilterDrawerShell
      open={showFilterDrawer}
      onClose={handleFilterDrawer}
      activeCount={countActive(filters, [...ISSUED_KEYS, ...RETURNED_KEYS])}
      onClearAll={handleClearAll}
      onApply={handleApplyFilter}
      applying={filterLoading}
      applyDisabled={!isFilterDirty}
    >
      <FilterSection title="Issued" count={countActive(filters, ISSUED_KEYS)}>
        <DateRangeFields
          label="Issued between"
          fromId="issued_date_after"
          toId="issued_date_before"
          fromValue={valueOf("issued_date_after")}
          toValue={valueOf("issued_date_before")}
          onFromChange={(v) => handleDateChange(v, "issued_date_after")}
          onToChange={(v) => handleDateChange(v, "issued_date_before")}
        />
      </FilterSection>
      <FilterSection title="Returned" count={countActive(filters, RETURNED_KEYS)}>
        <DateRangeFields
          label="Returned between"
          fromId="returned_date_after"
          toId="returned_date_before"
          fromValue={valueOf("returned_date_after")}
          toValue={valueOf("returned_date_before")}
          onFromChange={(v) => handleDateChange(v, "returned_date_after")}
          onToChange={(v) => handleDateChange(v, "returned_date_before")}
        />
      </FilterSection>
    </FilterDrawerShell>
  );
};
export default AssetFilterDrawer;
